import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import MetterFirst from "@/pages/MetterFirst";
import DataCenter from "@/pages/DataCenter";
import Residential from "@/pages/Residential";
import Community from "@/pages/Community";
import Partners from "@/pages/Partners";
import DataRoom from "@/pages/DataRoom";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SiteSubmission from "@/pages/SiteSubmission";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/metter-first" element={<MetterFirst />} />
              <Route path="/data-centers" element={<DataCenter />} />
              <Route path="/residential" element={<Residential />} />
              <Route path="/community" element={<Community />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/data-room" element={<DataRoom />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/site-submission" element={<SiteSubmission />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
